import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { CustomizationModel } from './model/customization.model';
import { CustomizationService } from './customization.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, SortDirection } from '@angular/material/sort';
import { EmployeeCategoryModel } from '../../employees/employee-category/employee-category/model/employee-category.model';
import { forkJoin } from 'rxjs';
import { PermissionService } from 'src/app/auth/permission.service';
import { SaleItemService } from '../sale-item/sale-item.service';
import { AppConstants } from 'src/app/common/app.constants';
import { StorageService } from 'src/app/common/services/storage.service';


@Component({
  selector: 'app-customization',
  templateUrl: './customization.component.html',
  styleUrls: ['./customization.component.scss'],
  standalone: false
})
export class CustomizationComponent {

  customizationList: CustomizationModel[] = [];
  showSearch: boolean = false;
  isLoading = true;
  filter: FilterListItemModel[] = [];
  displayedColumns = ['code', 'name', 'display_name', 'value_name', 'option_for', 'action'];
  pagingData = { length: 0, pageSize: 50, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: CustomizationModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<CustomizationModel>(true, []);
  dataSource = new MatTableDataSource(this.customizationList);
  IsDownloading: boolean = false;
  context: any = [];
  isFilterReady = false;
  permission: any;
  saleItems: any;

  constructor(private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private snackBarService: SnackBarService,
    private customizationService: CustomizationService,
    public permissionService: PermissionService,
    private router: Router, private stateManagerService: StateManagerService,
    private saleItemService: SaleItemService,
    private storageService: StorageService) {
    this.permission = permissionService.getPagePermission("customization");
    this.customizationList = [];
    // this.context = [{ id: 1, name: 'Discount' },{ id: 2, name: 'Refund' }];
  }
  /**
    * initilaize the device model
    */
  ngOnInit(): void {
    this.storageService.clearSessionByName(AppConstants.SESSION_VAR_CUST_SALE_ITEMS);
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });
    this.generateFilterList();
    const storedSaleItems = sessionStorage.getItem(AppConstants.SESSION_VAR_CUST_SALE_ITEMS);
    if (storedSaleItems == null || storedSaleItems == undefined) {
      this.getCustomizationSaleItems();
    }
  }

  generateFilterList() {
    this.filter = [
      {
        title: "Code",
        column: "customization_option.code",
      },
      {
        title: "Name",
        column: "customization_option.name",
      },
      {
        title: "Display Name",
        column: "customization_option.display_name",
      },
      {
        title: "Values",
        column: "customization_option.name",
      },
      {
        title: "Option For",
        column: "customization_option.option_for",
      }
    ];
  }

  /** 
  * Set the datasource
  */
  setDataSource(menuList: CustomizationModel[]) {
    this.dataSource = new MatTableDataSource(menuList);
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {

    this.loadPreviousState();
    // this.loadData();
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.setSortColumn('customization_option.name', 'asc');
      this.loadData();
    }

  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });

    let sortId = column;
    if (sortId && sortId.startsWith("customization_option.")) {
      sortId = sortId.replace("customization_option.", "");
    }

    this.sort.sort({
      id: sortId,
      start: direction,
      disableClear: false,
    });

    // this.sort.active=column;
    // this.sort.direction=direction;


  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.customizationList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.customizationList);
  }

  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: [
            ...(searchParam.advSearch || []),
            ...this.getDefaultSearchParams(searchParam.advSearch),
          ],
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }


  getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
    var defFilter: any = [];
    if (
      searchFilter == undefined ||
      !searchFilter.some((sf: any) => sf.column == "is_system")
    ) {
      defFilter.push({
        column: "is_system",
        operator: "=",
        value: "0",
      });
    }
    return defFilter;
  }

  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();

  }

  onDuplicate(customizationInfo: CustomizationModel): void {

    if (customizationInfo.id === undefined) {
      // Optionally show an error or return early
      return;
    }
    this.customizationService.getCustomizationById(customizationInfo.id).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          const customizationItem = response.data.customization;
          const customizationOptionValues = response.data.customization_option_value;
          const newCustomization = {
            ...customizationItem,
            id: 0, // treat as new
            code: '', // let user enter a new code
            name: customizationItem.name,
            description: customizationItem.description ? customizationItem.description : '',
            display_order: customizationItem.display_order ? customizationItem.display_order : '',
            display_name: customizationItem.display_name ? customizationItem.display_name : '',
            option_for: customizationItem.option_for ? customizationItem.option_for : '',
            bg_color: customizationItem.bg_color ? customizationItem.bg_color : '',
            fg_color: customizationItem.fg_color ? customizationItem.fg_color : '',
            customizationOptionValues: customizationOptionValues
              ? customizationOptionValues.map((v: any) => ({ ...v, id: 0 }))
              : []
          };

          this.router.navigate(['product/customization-edit', 0], { state: { customizationData: newCustomization } });
        }
      },
      error: () => {
        // Optionally handle error
      }
    });
  }
  /**
    * On delete menu item selected
    * Confirm the action and call the api to update
    */
  onDelete(menuInfo: CustomizationModel): void {
    const menuId = menuInfo.id;
    const message = `Are you sure, you want to delete ` + (menuInfo.name + "?");
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      if (dialogResult) {
        this.customizationService.delete(menuInfo).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              // handle success
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' + menuInfo.name + " has been deleted succesfully."
              }
              this.snackBarService.openSnackBar(snckBarData);
              this.loadData();
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }

  /**
   * loads the data based on the conditions
   */
  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.customizationService.getCustomizationList(requestData).subscribe(response => {
      if (response.status === 'SUCCESS') {
        this.customizationList = response.data.customization;
        this.generateFilterList();
        this.isFilterReady = true;
        this.setDataSource(this.customizationList);

        // console.log(this.context )
        this.pagingData.length = response.data.total_count;

        if (this.pagingData.length === 0) {
          const snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          };
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
          this.stateManagerService.setState(this.constructor.name, requestData);
          // this.onRowSelected(this.expenseList[0]);
        }

      } else {
        const snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        };
        this.snackBarService.openSnackBar(snackBarData);
      }

      this.isLoading = false;
    });
  }

  getContextName(value: number): string {
    const context = this.context.find((r: any) => r.value === value);
    return context ? context.name : '';
  }

  /**
  * On menuInfo selected
  * @param menuInfo 
  */
  onRowSelected(menuInfo: CustomizationModel): void {
    this.selectedItem = menuInfo;
    this.showSummaryPanel = true;
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {

    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: "customization_option." + sd.active, order: sd.direction });
    this.loadData();
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(customizationInfo: CustomizationModel): void {

    this.router.navigate(['product/customization-edit', customizationInfo.id]);
  }


  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }

  /**
   * On Add clicked
   * Show the dialog to enter new menu
   */
  addClicked(): void {

    this.router.navigate(['product/customization-edit', 0]);

  }

  exportClicked() {
    if (this.pagingData.length === 0) {
      let snackBarData: SnackBarData = {
        message: 'No data found to export. Please remove or change the filter if any.',
        title: 'No Data!!!',
        type: 'warn'
      };
      this.snackBarService.openSnackBar(snackBarData);
      return;
    }
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.customizationService['downloadExcel'](requestData)
      .subscribe({
        next: (blob: Blob | MediaSource) => {
          // Download logic
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'customization_option_list.csv'; // Adjust filename if needed
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;


        },
        error: (_error: any) => {
          // Handle errors
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.isLoading = false;
          // Display user-friendly error message to the user
        }
      }
      );
  }

  getCustomizationSaleItems() {
    const requestData: RequestData =
    {
      search: {
        filters: {
          advSearch:
            [
              {
                column: "sale_item.item_type",
                operator: "=",
                value: 1
              },
              {
                column: "item_classes.is_customization",
                operator: "=",
                value: 1
              },
              {
                column: "sale_item.is_valid",
                operator: "=",
                value: 1
              }
            ],
          scope: {
            limit: 5000,
            offset: 0
          }
        },
        sort: [

        ]
      }
    };


    this.saleItemService.getList(requestData).subscribe({
      next: (response: any) => {
        if (response.status === 'SUCCESS') {
          this.saleItems = response.data.items;
          // Sort sale items by name in ascending order
          this.saleItems.sort((a: any, b: any) => a.name.localeCompare(b.name));
          if (this.saleItems !== null && this.saleItems !== undefined) {
            sessionStorage.setItem(AppConstants.SESSION_VAR_CUST_SALE_ITEMS, JSON.stringify(this.saleItems));
          }
          // console.log('Sale items loaded successfully:', this.saleItems.length);
        } else {
          // console.error('Failed to load sale items:', response.message);
        }
      },
      error: (error: any) => {
        // console.error('API error when loading sale items:', error);
      }
    });
  }

}

